<template>
  <div class="banner-img-container">
    <video
      v-if="backgroundVideo"
      autoplay
      loop
      muted
      controls
      class="video-container"
      id="vid"
    >
      <source :src="backgroundVideo" type="video/mp4" />
      Sorry, your browser doesn't support embedded videos.
    </video>
    <div class="banner-mask"></div>
    <div class="slot-container" v-bind="$attrs" ref="slot">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import { ref, computed, onMounted } from "vue";

//eslint-disable-next-line
const props = defineProps({
  backgroundImage: {
    type: String,
    required: false,
  },
  backgroundVideo: {
    type: String,
    required: false,
  },
});

//eslint-disable-next-line
defineOptions({
  inheritAttrs: false,
});

const slot = ref(null);

const backgroundImg = computed(() => {
  return `url(${encodeURI(props.backgroundImage)})`;
});

const height = ref("500px");

onMounted(() => {
  const resizeObserver = new ResizeObserver(() => {
    if (slot.value) {
      height.value = slot.value.clientHeight + "px";
    }
  });

  resizeObserver.observe(slot.value);
});
</script>

<style scoped>
.banner-img-container {
  width: 100%;
  position: relative;
  background-image: v-bind("backgroundImg");
  top: 0;
  z-index: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: v-bind("height");
}

.banner-img {
  width: 100%;
}

.banner-mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.65);
  width: 100%;
  height: 100%;
  z-index: 1;
}

.video-container {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  left: 0;
}

.slot-container {
  padding: 3rem 1rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
</style>
